import { render, staticRenderFns } from "./StatisticField.vue?vue&type=template&id=f866de52&scoped=true&"
import script from "./StatisticField.vue?vue&type=script&lang=js&"
export * from "./StatisticField.vue?vue&type=script&lang=js&"
import style0 from "./StatisticField.vue?vue&type=style&index=0&id=f866de52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f866de52",
  null
  
)

export default component.exports